var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.125C7.44248 1.125 5.91992 1.58686 4.62489 2.45218C3.32985 3.31749 2.32049 4.5474 1.72445 5.98637C1.12841 7.42534 0.972461 9.00874 1.27632 10.5363C1.58018 12.0639 2.3302 13.4671 3.43154 14.5685C4.53288 15.6698 5.93607 16.4198 7.46367 16.7237C8.99127 17.0275 10.5747 16.8716 12.0136 16.2756C13.4526 15.6795 14.6825 14.6702 15.5478 13.3751C16.4131 12.0801 16.875 10.5575 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125V1.125ZM9 4.5C9.16688 4.5 9.33001 4.54948 9.46877 4.6422C9.60752 4.73491 9.71567 4.86669 9.77953 5.02086C9.84339 5.17504 9.8601 5.34469 9.82754 5.50836C9.79499 5.67203 9.71463 5.82237 9.59662 5.94037C9.47862 6.05837 9.32828 6.13873 9.16461 6.17129C9.00094 6.20384 8.83129 6.18713 8.67711 6.12327C8.52294 6.05941 8.39116 5.95127 8.29845 5.81251C8.20574 5.67376 8.15625 5.51063 8.15625 5.34375C8.15625 5.11997 8.24515 4.90536 8.40338 4.74713C8.56162 4.58889 8.77623 4.5 9 4.5ZM11.25 13.5703H6.75V12.3047H8.36719V9.07031H7.3125V7.80469H9.63282V12.3047H11.25V13.5703Z",
    fill: "#3382FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/infoBlue.a6f92a87cb2338b9117d58b29f5920f0.svg";
export { ForwardRef as ReactComponent };